// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.accountview.properties.RentalManagerAccountViewZramSingleFamilyV2WebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerAccountViewZramSingleFamilyV2WebApiHandler_advertising,
  RentalManagerAccountViewZramSingleFamilyV2WebApiHandler_advertising_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

import type { AccountViewListingAdvertisingDto, ListingAlias } from '@zg-rentals/ts-rental-manager-api-client';

interface AdvertisingParams {
  listingAlias: ListingAlias;
}

export type RentalManagerAccountViewZramSingleFamilyV2WebApiHandler_advertising_Options = UseQueryOptions<
  AccountViewListingAdvertisingDto,
  unknown,
  AccountViewListingAdvertisingDto,
  readonly [string, AdvertisingParams]
>;

const RentalManagerAccountViewZramSingleFamilyV2WebApiHandler_advertising_GetKey = (getParams: AdvertisingParams) =>
  [RentalManagerAccountViewZramSingleFamilyV2WebApiHandler_advertising_Path, getParams] as const;

export const RentalManagerAccountViewZramSingleFamilyV2WebApiHandler_advertising_queryOptions = (
  getParams: AdvertisingParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerAccountViewZramSingleFamilyV2WebApiHandler_advertising_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZramSingleFamilyV2WebApiHandler_advertising(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get single family customer account view property listing advertising
 */
export const useRentalManagerAccountViewZramSingleFamilyV2WebApiHandler_advertising = (
  getParams: AdvertisingParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerAccountViewZramSingleFamilyV2WebApiHandler_advertising_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerAccountViewZramSingleFamilyV2WebApiHandler_advertising_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerAccountViewZramSingleFamilyV2WebApiHandler_advertising.getKey =
  RentalManagerAccountViewZramSingleFamilyV2WebApiHandler_advertising_GetKey;
